/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type FavoritesProvider_viewer = {| |};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "selectedItemIds",
      "type": "[String]",
      "defaultValue": []
    },
    {
      "kind": "LocalArgument",
      "name": "loadPortfolioData",
      "type": "Boolean",
      "defaultValue": false
    },
    {
      "kind": "LocalArgument",
      "name": "shouldFillInFolder",
      "type": "Boolean",
      "defaultValue": false
    },
    {
      "kind": "LocalArgument",
      "name": "userIds",
      "type": "[String]",
      "defaultValue": []
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "FavoritesProvider_viewer",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "FolderWrapper_viewer",
      "args": [
        {
          "kind": "Variable",
          "name": "selectedItemIds",
          "variableName": "selectedItemIds",
          "type": null
        },
        {
          "kind": "Variable",
          "name": "shouldFillInFolder",
          "variableName": "shouldFillInFolder",
          "type": null
        },
        {
          "kind": "Variable",
          "name": "userIds",
          "variableName": "userIds",
          "type": null
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "HeartWrapper_viewer",
      "args": [
        {
          "kind": "Variable",
          "name": "loadPortfolioData",
          "variableName": "loadPortfolioData",
          "type": null
        },
        {
          "kind": "Variable",
          "name": "selectedItemIds",
          "variableName": "selectedItemIds",
          "type": null
        },
        {
          "kind": "Variable",
          "name": "userIds",
          "variableName": "userIds",
          "type": null
        }
      ]
    }
  ],
  "type": "Viewer"
};

module.exports = fragment;
